import * as React from 'react';

import { TranslateFunction } from '@own-local/ad-utils/lib/types';

export interface ContactContentProps {
  active: boolean;
  email: string;
  locale: string;
  name: string;
  headline: string;
  translateString: TranslateFunction;
}

export interface ContactContentState {
  bodyText: string;
}

export default class ContactContent extends React.Component<ContactContentProps, ContactContentState > {
  constructor(props: ContactContentProps) {
    super(props);
    this.state = {
      bodyText: props.translateString(
        'body_message_contact_info',
        props.locale,
        "I'm interested in more information about this offer: ",
        { "headline": props.headline.replace("<br>", " ").replace("##", "/").replace("&", "-and-").replace("<br>", "") }
      )
    };
  }

  public render() {
    const { active, locale, translateString, email, name } = this.props;

    let adName = name.replace("<br>", " ")

    let emailSubject = translateString(
      'contact_email_subject',
      locale,
      `Re: Ad in '${adName}' Website`,
      { "name": adName }
    );

    return (
      <div className={`content-wrapper contact ${active && 'content-active'}`}>
        <textarea
          className="email-body-text"
          placeholder="Your Message"
          value={this.state.bodyText}
          onChange={(event) => {
            this.setState({
              bodyText: event.target.value
            });
          }}
        >
        </textarea>
        <a className="send-email-button" target="_top" href={`mailto:${email}?subject=${emailSubject}&body=${this.state.bodyText.replace("%", "%25")}`}>
          <span className='mdi mdi-open-in-app'></span>
          {translateString('contact_by_email', locale, 'Send in Email App')}
        </a>
      </div>
    );
  }
}
